import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init(){
        this.image = this.el.querySelector('img');
        this.caption = this.el.querySelector('figcaption');
        if (this.image && this.caption) {
            const imgWidth = this.image.getAttribute('width');
            this.caption.style.width = imgWidth + 'px';
        }
    }
}
